import { render } from "./LanguagePrefernce.vue?vue&type=template&id=1e2037f4&scoped=true"
import script from "./LanguagePrefernce.vue?vue&type=script&lang=js"
export * from "./LanguagePrefernce.vue?vue&type=script&lang=js"

import "./LanguagePrefernce.vue?vue&type=style&index=0&id=1e2037f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2037f4"]])

export default __exports__